import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/word_ladder.json";
import fr from "@/locales/fr/puzzle-types/word_ladder.json";

export const WORD_LADDER_NS = "puzzle-types/word_ladder";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerWordLadderTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", WORD_LADDER_NS))
    i18n.addResourceBundle("en", WORD_LADDER_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", WORD_LADDER_NS))
    i18n.addResourceBundle("fr", WORD_LADDER_NS, fr, true, true);
}
